"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { FC } from "react";

const Footer: FC = () => {
  const t = useTranslations();

  return (
    <footer className="flex w-full justify-center border-t border-gray-300 px-4 py-4 text-sm text-gray-500 dark:border-blue-800 dark:text-gray-400">
      <div className="flex w-full max-w-[1352px] items-center justify-between">
        <span>
          Based on the open source{" "}
          <Link
            href="https://github.com/Metaculus/metaculus"
            className="no-underline hover:text-gray-700 dark:hover:text-gray-300"
          >
            Metaculus project
          </Link>
          .
        </span>
        <div className="flex gap-6">
          <Link
            href="https://discord.gg/z6RY7ZH57m"
            target="_blank"
            rel="noreferrer"
            className="no-underline hover:text-gray-700 dark:hover:text-gray-300"
          >
            {t("discord")}
          </Link>
          <Link
            href="/privacy-policy/"
            className="no-underline hover:text-gray-700 dark:hover:text-gray-300"
          >
            {t("privacyPolicy")}
          </Link>
          <Link
            href="/terms-of-use/"
            className="no-underline hover:text-gray-700 dark:hover:text-gray-300"
          >
            {t("termsOfUse")}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
